import { shallowRef } from 'vue';
import type { GlobalTheme } from 'naive-ui';

export const discreteAppTheme = shallowRef<GlobalTheme | null>(null);
